export class NonAnonymousActions {
	public static AddToSharedLibrary = 'sharedoc';
	public static RequestNewVersion = 'upddoc';
	public static RightsInfo = 'rights';
	public static SupplementalRequest = 'smrequest';
}

export const OrderViewerColors = {
	success500: '#65bc19',
	error500: '#ce331c'
};
